module.exports = __webpack_public_path__ + "img/Ellipse4.39893af8.png";